import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import { Icon, Switch } from "@mui/material";
import PropTypes from "prop-types";
import SoftButton from "components/SoftButton";

function Title({ title, subTitle }) {
    return (
        <SoftBox display="flex" alignItems="center" px={1} py={0.5}>
            <SoftBox display="flex" flexDirection="column">
                <SoftTypography variant="button" fontWeight="medium">
                    {title}
                </SoftTypography>
                <SoftTypography variant="caption" color="secondary">
                    {subTitle}
                </SoftTypography>
            </SoftBox>
        </SoftBox>
    );
}
Title.defaultProps = {
    title: "",
    subTitle: "",
};
Title.propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string.isRequired,
};

function Slug({ job }) {
    return (
        <SoftBox display="flex" flexDirection="column">
            <SoftTypography variant="caption" fontWeight="medium" color="text">
                {job}
            </SoftTypography>
        </SoftBox>
    );
}
Slug.defaultProps = {
    job: "",
};
Slug.propTypes = {
    job: PropTypes.string.isRequired,
};

function Actions({ currentCategoryData, handleEditItem, handleDeleteItem }) {
    return <>
        <SoftButton variant="gradient" color="info" iconOnly={true} onClick={() => handleEditItem(currentCategoryData)}>
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={() => handleEditItem(currentCategoryData)}>
                create
            </Icon>
        </SoftButton>
        &nbsp;
        <SoftButton variant="gradient" color="error" iconOnly={true} onClick={() => handleDeleteItem(currentCategoryData)}>
            <Icon sx={{ cursor: "pointer", fontWeight: "bold" }} fontSize="small" onClick={() => handleDeleteItem(currentCategoryData)}>
                delete
            </Icon>
        </SoftButton>
    </>;
}
Actions.defaultProps = {
    currentCategoryData: {},
    handleEditItem: () => { },
    handleDeleteItem: () => { },
    addEditJobCategory: () => { }
};
Actions.propTypes = {
    currentCategoryData: PropTypes.object.isRequired,
    handleEditItem: PropTypes.func.isRequired,
    handleDeleteItem: PropTypes.func.isRequired,
    addEditJobCategory: PropTypes.func.isRequired,
};
function jobCategoryListing(categoryData, handleEditItem, handleDeleteItem, addEditJobCategory) {
    return {
        columns: [
            { colummKey: "title", name: "Title", align: "left" },
            { colummKey: "slug", name: "Slug", align: "left" },
            { colummKey: "status", name: "Status", align: "center" },
            { colummKey: "action", name: "Action", align: "center" },
        ],

        rows: categoryData ? categoryData.map((singleCategory, categoryIndex) => {
            return {
                title: <Title
                    title={singleCategory.name}
                    subTitle={
                        singleCategory.parent_category !== '' && singleCategory.parent_category !== null ?
                            'Parent Category : ' + singleCategory.parent_category :
                            ''
                    } />,
                slug: <Slug
                    job={singleCategory.slug} />,
                status: (
                    <Switch
                        color="success" 
                        defaultChecked={singleCategory.status === 1 ? true : false}
                        onChange={(event) => {
                            singleCategory['status']=event.target.checked ? 1 : 0;
                            addEditJobCategory(singleCategory);
                        }} />
                ),
                action: (
                    <Actions
                        currentCategoryData={singleCategory}
                        handleEditItem={handleEditItem}
                        handleDeleteItem={handleDeleteItem} />
                )
            };
        }) : [],
    };
};

export default jobCategoryListing;
